import { render, staticRenderFns } from "./SignUpBanner.vue?vue&type=template&id=37ed5107&scoped=true"
import script from "./SignUpBanner.vue?vue&type=script&lang=ts"
export * from "./SignUpBanner.vue?vue&type=script&lang=ts"
import style0 from "./SignUpBanner.vue?vue&type=style&index=0&id=37ed5107&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "37ed5107",
  null
  
)

export default component.exports